import { ROUTES } from "@/routes_new";
import { Route, Switch } from "react-router-dom";
import { SignupProvider } from "./context";
import SignupIndex from "./partials";
import SignupInfo from "./partials/info";
import SignupConfirm from "./partials/confirm";

export default function SignupViewNew() {
  return (
    <SignupProvider>
      <Switch>
        <Route exact path={ROUTES.SIGNUP_LOCALIZED} component={SignupIndex} />
        <Route
          exact
          path={ROUTES.SIGNUP_INFO_LOCALIZED}
          component={SignupInfo}
        />
        <Route
          exact
          path={ROUTES.SIGNUP_CONFIRM_LOCALIZED}
          component={SignupConfirm}
        />
      </Switch>
    </SignupProvider>
  );
}
